import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'rb-unit-of-measures',
  imports: [RouterOutlet],
  templateUrl: './unit-of-measures.component.html',
  styleUrl: './unit-of-measures.component.scss',
})
export class UnitOfMeasuresComponent {}
